import type { PropsWithChildren } from "react";
import { useWorkspacePortfolioNavigationSections } from "@/components/sidebar/portfolio-sidebar-items";
import { hasWorkspacePortfolio } from "@/components/sidebar/workspace-entry";
import { useWorkspaceAdmin } from "@/hooks/use-workspace-admin";
import type { WorkspacePortfolioTab } from "@/lib/schema";
import { Layout } from "./layout";
import { WorkspaceNoAccessState } from "./workspace/workspace-no-access-state";

export const WorkspacePortfolioLayout = ({ page, children }: { page: WorkspacePortfolioTab } & PropsWithChildren) => {
  const { isLoading, workspace } = useWorkspaceAdmin();
  const sections = useWorkspacePortfolioNavigationSections();
  const hasAccess = !isLoading && !!workspace && hasWorkspacePortfolio(workspace);

  return (
    <Layout activeTab={page} sections={sections}>
      {isLoading ? null : hasAccess ? children : <WorkspaceNoAccessState />}
    </Layout>
  );
};
